import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { useSelector } from 'react-redux';
import { companiesApiSlice } from '../../../../../store/api-slices';
import { selectCompanyId } from '../../../../../store/slices/InitialDataSlice';
import { store } from '../../../../../store';

interface ErrorPayload {
  product_ids: number[];
  modifier_ids: number[];
}

const useOutOfStockErrorHandler = () => {
  const companyId = useSelector(selectCompanyId);

  const handler = (response: RenderableErrorResponse<ErrorPayload>): void => {
    const productIds = response?.response?.data?.payload?.product_ids ?? [];
    const modifierIds = response?.response?.data?.payload?.modifier_ids ?? [];

    store.dispatch(
      companiesApiSlice.util.updateQueryData('getCompanyMenusData', companyId, (draft) => {
        // The cached menu can predate the item the backend names, so unknown ids are skipped.
        productIds.forEach((productId) => {
          if (draft.products?.[productId]) {
            draft.products[productId].is_available = false;
          }
        });
        modifierIds.forEach((modifierId) => {
          if (draft.modifiers?.[modifierId]) {
            draft.modifiers[modifierId].is_available = false;
          }
        });
      }),
    );
  };

  return handler;
};

export default useOutOfStockErrorHandler;
